'use strict';
module.exports = require('./Tooltip.js');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/tooltip/index.js
// module id = 60
// module chunks = 7